const getLocalDateFromUtc = (date:any) => {
    return new Date(date + 'z');
}

export {
    getLocalDateFromUtc,
}